import { BrowserRouter as Router } from 'react-router-dom';
import NavBar from './Components/NavBar';
import './styles.css';
import WritingPad from './Components/WritingPad';
import { TextContextProvider } from './Components/Context';
import ViewingPad from './Components/ViewingPad';

function App() {
  return (
    <Router>
      <TextContextProvider>
        <div>
          <NavBar />
          <div className="main-part">
            <WritingPad />
            <ViewingPad />
          </div>
        </div>
      </TextContextProvider>
    </Router>
  );
}

export default App;
